import * as actions from './actionTypes';
import { CalculationRes, Offer, OfferBase } from 'api';

export interface CalculationResCustomKey extends CalculationRes {
	[key: string]: any | any[];
}

export interface IOfferAttachment {
	id: number;
	file: Blob;
}

export interface IOfferSearchStore {
	offers: Offer[];
	chartOffers: OfferBase[];
	offer?: Offer;
	offerFiles: Array<IOfferAttachment>;
	calculation: CalculationResCustomKey;
	isLoading: boolean;
	isLocked: boolean;
	error?: string;
}

export const INITIAL_STATE: IOfferSearchStore = {
	offers: [],
	chartOffers: [],
	offer: undefined,
	offerFiles: [],
	calculation: {},
	isLoading: false,
	isLocked: false,
	error: '',
};

const OfferSearchData = (
	state = INITIAL_STATE,
	action: { type: string; payload: any }
): IOfferSearchStore => {
	switch (action.type) {
		case actions.GET_OFFER:
		case actions.GET_OFFERS_ALL:
		case actions.GET_DASHBOARD_OFFERS:
		case actions.GET_DASHBOARD_DATA:
		case actions.GET_OFFERS_SEARCH:
		case actions.GET_CUSTOMER_DATA:
			state = {
				...state,
				isLoading: true,
			};
			break;

		case actions.SET_CUSTOMER_DATA:
			state = {
				...state,
				offer: {
					...state.offer,
					customerData: { ...action.payload },
				},
			};
			break;

		case actions.SET_OFFER:
			state = {
				...state,
				offer: {
					...action.payload,
					offerParams: {
						...action.payload.offerParams,
						optionalMessage: '',
					},
				},
				isLoading: false,
			};
			break;

		case actions.SET_OFFERS:
			state = {
				...state,
				offers: [...action.payload],
				isLoading: false,
			};
			break;

		case actions.SET_CHART_OFFERS:
			state = {
				...state,
				chartOffers: [...action.payload],
				isLoading: false,
			};
			break;

		case actions.OFFER_CALCULATE:
			state = {
				...state,
				isLoading: true,
			};
			break;

		case actions.OFFER_CALCULATE_SUCCESS:
			state = {
				...state,
				calculation: action.payload,
				isLoading: false,
			};
			break;

		case actions.OFFER_CALCULATE_RESET:
			state = {
				...state,
				calculation: {},
			};
			break;

		case actions.OFFERS_ERROR:
			state = {
				...state,
				error: action.payload,
				isLoading: false,
			};
			break;

		case actions.OFFER_CLEAR_ERROR:
			state = {
				...state,
				error: '',
			};
			break;

		case actions.OFFER_RESET:
			state = {
				...state,
				offer: undefined,
				calculation: {},
				offerFiles: [],
			};
			break;

		case actions.OFFER_RESET_ALL:
			state = {
				...state,
				...INITIAL_STATE,
			};
			break;

		case actions.LOCK_OFFER_FORM:
			state = {
				...state,
				isLocked: true,
			};
			break;

		case actions.UNLOCK_OFFER_FORM:
			state = {
				...state,
				isLocked: false,
			};
			break;

		case actions.PREP_FILE_DOWNLOAD_SUCCESS:
			state = {
				...state,
				offerFiles: [...state.offerFiles, action.payload],
			};
			break;

		default:
			state = { ...state };
			break;
	}
	return state;
};

export default OfferSearchData;
